export default __webpack_public_path__ + "static/media/typeP_high_lamp.885c8fb4.png";